import { FC } from 'react';
import { ITextareaField, onTextAreaChangeHandler } from '../../../../types';
import { useGradientBorderStyles } from '../../../../hooks/useGradientBorderStyles';
import { EnhancedTextAreaInput } from './styled';

interface EnhancedTextareaProps {
  field: ITextareaField;
  onTextAreaChange: onTextAreaChangeHandler;
}

export const EnhancedTextarea: FC<EnhancedTextareaProps> = ({
  field,
  onTextAreaChange
}) => {
  const { inputBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: '#fff'
  });

  // ! render
  return (
    <EnhancedTextAreaInput
      multiline
      name={field.id}
      minRows={3}
      maxRows={15}
      className={inputBorderGradientClass}
      value={field.data}
      onChange={({ target: { value } }) => onTextAreaChange(field.id, value)}
    />
  );
};
